import { useEffect } from "react";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Hero } from "@/components/landing/Hero";
import { LegacyBand } from "@/components/landing/LegacyBand";
import { LiveStatsStrip } from "@/components/landing/LiveStatsStrip";
import { SupportCards } from "@/components/landing/SupportCards";
import { FounderSection } from "@/components/landing/FounderSection";
import { FeaturedAnimals } from "@/components/landing/FeaturedAnimals";
import { TrustStrip } from "@/components/landing/TrustStrip";
import { GuardianRepeatSection } from "@/components/landing/GuardianRepeatSection";
import { SuccessHighlight } from "@/components/landing/SuccessHighlight";
import { FinalCta } from "@/components/landing/FinalCta";
import { StickyMobileCta } from "@/components/landing/StickyMobileCta";
import { setMetaTag } from "@/lib/seo";
import { CANONICAL_URL } from "@/lib/api";

const HOME_OG_DESCRIPTION =
  "AMTM has rescued and treated 35,000+ street animals in Mumbai since 2010, with a zero-euthanasia promise. Follow every rescue transparently — help an animal recover today.";

export default function Landing() {
  useEffect(() => {
    document.title = "AMTM Rescue Hub | Animal Matter To Me";
    setMetaTag("og:title", "AMTM Rescue Hub | Animal Matter To Me");
    setMetaTag("og:description", HOME_OG_DESCRIPTION);
    setMetaTag("og:image", `${CANONICAL_URL}/images/sanctuary.jpg`);
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", HOME_OG_DESCRIPTION);
  }, []);

  return (
    <div className="min-h-screen bg-amtm-bg" data-testid="landing-page">
      <PublicHeader />
      <Hero />
      <LegacyBand />
      <LiveStatsStrip />
      <SupportCards />
      <FounderSection />
      <FeaturedAnimals />
      <TrustStrip />
      <GuardianRepeatSection />
      <SuccessHighlight />
      <FinalCta />
      <PublicFooter />
      <StickyMobileCta />
    </div>
  );
}
